<template>
  <!-- 单个对象(战队/个人) -->
  <div class="singleTeam" v-if="info?.questionDetail">
    <div class="left-box">
      <div class="icon-bg">
        <div class="icon">
          <div
            class="head"
            :style="{
              'background-image': `url(${$lg(objInfo, 'avatar', '')})`,
            }"
          ></div>
          <div class="frame"></div>
        </div>
        <div class="name">
          <div class="label-box">
            <span class="label-shadow">{{ $lg(objInfo, 'name', '-') }}</span>
            <span class="label-text">{{ $lg(objInfo, 'name', '-') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="middle-box">
      <div class="bg-decorate"></div>
      <div class="question">
        <div class="title">
          <div class="label-box">
            <span class="label-shadow">{{ $lg(info, 'questionDetail.title', '') }}</span>
            <span class="label-text">{{ $lg(info, 'questionDetail.title', '') }}</span>
          </div>
        </div>
      </div>
      <div class="compared">
        <div class="inner">
          <div class="yellow-side" :style="{ width: `${odd.leftOdd}%` }"></div>
          <div class="blue-side" :style="{ width: `${odd.rightOdd}%` }"></div>
        </div>
        <div class="desc yellow-desc">
          <div class="label-box" v-if="odd.leftOdd">
            <span class="label-shadow">{{ odd.leftOdd }} % 支持</span>
            <span class="label-text">{{ odd.leftOdd }} % 支持</span>
          </div>
          <div class="label-box" v-else>
            <span class="label-shadow">0 % 支持</span>
            <span class="label-text">0 % 支持</span>
          </div>
        </div>
        <div class="desc blue-desc">
          <div class="label-box" v-if="odd.rightOdd">
            <span class="label-shadow">{{ odd.rightOdd }} % 支持</span>
            <span class="label-text">{{ odd.rightOdd }} % 支持</span>
          </div>
          <div class="label-box" v-else>
            <span class="label-shadow">0 % 支持</span>
            <span class="label-text">0 % 支持</span>
          </div>
        </div>
      </div>
      <ul class="chooseList" v-if="$lg(info, 'questionDetail.answers', []).length != 0">
        <li v-for="(choose, index) in $lg(info, 'questionDetail.answers')" :key="`choose-${$lg(choose, 'answerCode', '')}`"
          @click="handleQuiz(info, info.questionDetail, choose, index)">
          <ui-frame-bg :colorType="colorMode[index]">
            <div class="label-box">
              <span class="label-shadow">{{ choose.answer }}</span>
              <span class="label-text">{{ choose.answer }}</span>
            </div>
          </ui-frame-bg>
          <!-- <span>{{ choose.answer }}</span> -->
          <div class="rate">赔率：{{ choose.lossRate }}</div>
        </li>
        <div class="vs-icon"></div>
      </ul>
    </div>
    <div class="right-box" v-if="$lg(objInfo1, 'avatar', '')">
      <div class="icon-bg">
        <div class="icon">
          <div
            class="head"
            :style="{
              'background-image': `url(${$lg(objInfo1, 'avatar', '')})`,
            }"
          ></div>
          <div class="frame"></div>
        </div>
        <div class="name">
          <div class="label-box">
            <span class="label-shadow">{{ $lg(objInfo1, 'name', '-') }}</span>
            <span class="label-text">{{ $lg(objInfo1, 'name', '-') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiFrameBg from '@/components/ui-frame-bg';
export default {
  inject: ['handleQuiz'],
  components: {
    UiFrameBg
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      objInfo: {},
      objInfo1: {},
      odd: {
        leftOdd:
          Number(this.info.questionDetail.answers[0]?.popularity * 100).toFixed(
            0
          ) || 0,
        rightOdd:
          Number(this.info.questionDetail.answers[1]?.popularity * 100).toFixed(
            0
          ) || 0
      },
      colorMode: ['yellow', 'blue'],
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal && newVal.questionDetail) {
          this.objInfo = newVal.questionDetail.objList[0] || {}
          this.objInfo1 = newVal.questionDetail.objList[1] || {}
          // console.log('objInfo', this.objInfo)
          // console.log('objInfo1', this.objInfo1)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/quiz/type/singleTeamOrMember.scss';
</style>